import * as React from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import Person4Icon from "@mui/icons-material/Person4";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import AuthenticationService from "../../../Service/AuthenticationService";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../../Router/Routes";
import AccountManagement from "../../Common/Modal/AccoutManagement";
import { getUserInformations } from "../../../Service/ApiService";
import Settings from "../../Common/Modal/Settings";
import StarIcon from "@mui/icons-material/Star";
import SourceIcon from "@mui/icons-material/Source";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, Grid, Typography, Zoom, Badge } from "@mui/material";
import { language_type } from "../../Dropdown";
import BarChartIcon from "@mui/icons-material/BarChart";
import { useEffect, useState } from "react";

const drawerWidth = 240;

const REACT_APP_COLOR = process.env.REACT_APP_COLOR || "#73AABF";

const useStyles = makeStyles((theme) => ({
  paper: {
    background: "blue",
  },
  itemText: {
    color: "white",
  },
}));

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(6)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  backgroundColor: "blue",
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const NavBar = (props: any) => {
  const { t } = useTranslation();

  useEffect(() => {
    setNotification(AuthenticationService.notification);
  }, [props.update]);

  const theme = useTheme();
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [accountManagement, setAccountManagement] = React.useState(false);
  const [settings, setSettings] = React.useState(false);
  const [userInformations, setUserInformations] = React.useState({} as any);
  //Permet de savoir qui a été séléctionné et ainsi pouvoir le faire changer de couleur
  const [current, setCurrent] = React.useState(0);
  const [notification, setNotification] = useState(
    AuthenticationService.notification
  );

  const closeAccountManagement = () => {
    setAccountManagement(false);
  };
  const closeSettings = () => {
    setSettings(false);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Drawer
        variant="permanent"
        open={open}
        PaperProps={{
          sx: {
            backgroundColor: "#2D3E4E",
            color: "white",
          },
        }}
      >
        <DrawerHeader>
          {!open ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              alignContent="center"
            >
              <Grid item xs={10}>
                <Zoom
                  in={open}
                  style={{ transitionDelay: open ? "100ms" : "0ms" }}
                >
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    alignContent="center"
                  >
                    <Grid item xs={8}>
                      <Typography
                        variant="h6"
                        style={{
                          textAlign: "center",
                          fontFamily: "'Samurai', sans-serif",
                        }}
                      >
                        SAMURAI
                      </Typography>
                    </Grid>
                  </Grid>
                </Zoom>
              </Grid>
              <Grid item xs={2}>
                <IconButton onClick={handleDrawerClose}>
                  {theme.direction !== "rtl" && (
                    <ChevronLeftIcon className={classes.itemText} />
                  )}
                </IconButton>
              </Grid>
            </Grid>
          )}
        </DrawerHeader>
        <Divider color="white" />
        <List>
          {[
            t("navBar.all"),
            t("navBar.completed"),
            t("navBar.onHold"),
            t("navBar.favorite"),
            t("navBar.projects"),
          ].map((text, index) => (
            <ListItem key={text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={() => {
                  if (index === 0) {
                    setCurrent(0);
                    props.changeCurrentPage("Requests");
                  } else if (index === 1) {
                    setCurrent(1);
                    props.changeCurrentPage("CompletedRequest");
                  } else if (index === 2) {
                    setCurrent(2);
                    props.changeCurrentPage("OnHoldRequest");
                  } else if (index === 3) {
                    setCurrent(3);
                    props.changeCurrentPage("Favorite");
                  } else if (index === 4) {
                    setCurrent(4);
                    props.changeCurrentPage("Projects");
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    color: "white",
                  }}
                >
                  {index === 0 ? (
                    <Badge
                      color="secondary"
                      badgeContent={notification.request.length}
                    >
                      <AllInboxIcon
                        style={{
                          color: current === 0 ? REACT_APP_COLOR : undefined,
                        }}
                      />
                    </Badge>
                  ) : index === 1 ? (
                    <MarkEmailReadIcon
                      style={{
                        color: current === 1 ? REACT_APP_COLOR : undefined,
                      }}
                    />
                  ) : index === 2 ? (
                    <MarkunreadIcon
                      style={{
                        color: current === 2 ? REACT_APP_COLOR : undefined,
                      }}
                    />
                  ) : index === 3 ? (
                    <StarIcon
                      style={{
                        color: current === 3 ? REACT_APP_COLOR : undefined,
                      }}
                    />
                  ) : (
                    <Badge
                      color="secondary"
                      badgeContent={notification.project.length}
                    >
                      <SourceIcon
                        style={{
                          color: current === 4 ? REACT_APP_COLOR : undefined,
                        }}
                      />
                    </Badge>
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  sx={{ opacity: open ? 1 : 0 }}
                  style={{
                    color: index === current ? REACT_APP_COLOR : undefined,
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider color="white" />
        <List>
          {/* {[t("navBar.userManagement"), t("navBar.statistics")].map( */}
          {[t("navBar.userManagement")].map((text, index) => (
            <ListItem key={text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={() => {
                  if (index === 0) {
                    setCurrent(5);
                    props.changeCurrentPage("UserManagement");
                  } else if (index === 1) {
                    setCurrent(6);
                    props.changeCurrentPage("Statistics");
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    color: "white",
                  }}
                >
                  {index === 0 ? (
                    <ManageAccountsIcon
                      style={{
                        color: current === 5 ? REACT_APP_COLOR : undefined,
                      }}
                    />
                  ) : (
                    <BarChartIcon
                      style={{
                        color: current === 6 ? REACT_APP_COLOR : undefined,
                      }}
                    />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  sx={{ opacity: open ? 1 : 0 }}
                  style={{
                    color:
                      index === 0 && current === 5
                        ? REACT_APP_COLOR
                        : index === 1 && current === 6
                        ? REACT_APP_COLOR
                        : undefined,
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider color="white" />
        <List>
          {[t("navBar.account"), t("navBar.settings")].map((text, index) => (
            <ListItem key={text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={() => {
                  if (index === 0) {
                    getUserInformations(
                      AuthenticationService.email,
                      AuthenticationService.token
                    )
                      .then((data) => {
                        setUserInformations(data);
                        setAccountManagement(true);
                      })
                      .catch((error) => console.error(error));
                  } else if (index === 1) {
                    setSettings(true);
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    color: "white",
                  }}
                >
                  {index === 0 ? (
                    <Person4Icon />
                  ) : (
                    <SettingsApplicationsIcon
                      sx={{
                        "& svg": {
                          color: "rgba(255,255,255,0.8)",
                          transition: "0.2s",
                          transform: "translateX(0) rotate(0)",
                        },
                        "&:hover, &:focus": {
                          bgcolor: "unset",
                          "& svg:first-of-type": {
                            transform: "translateX(-4px) rotate(-20deg)",
                          },
                          "& svg:last-of-type": {
                            right: 0,
                            opacity: 1,
                          },
                        },
                        "&:after": {
                          content: '""',
                          position: "absolute",
                          height: "80%",
                          display: "block",
                          left: 0,
                          width: "1px",
                          bgcolor: "divider",
                        },
                      }}
                    />
                  )}
                </ListItemIcon>
                <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Select
          SelectDisplayProps={{ style: { paddingTop: 8, paddingBottom: 8 } }}
          style={{
            color: "white",
            margin: "5px",
            textAlign: "center",
            fontSize: 16,
            height: "35px",
          }}
          renderValue={(value) => {
            const data = language_type.find((option) => option.value === value);
            if (data !== undefined) {
              return (
                <MenuItem
                  key={data.value}
                  value={data.value}
                  style={{ textAlign: "center" }}
                >
                  <img
                    src={data.flag}
                    alt={data.label}
                    style={{
                      minHeight: "15px",
                      maxHeight: "15px",
                      minWidth: "18px",
                      maxWidth: "18px",
                      textAlign: "center",
                    }}
                  />
                  {open && <ListItemText>{data.label}</ListItemText>}
                </MenuItem>
              );
            }
          }}
          inputProps={{
            IconComponent: () => null,
            sx: { padding: "0 !important" },
          }}
          value={AuthenticationService.language}
          sx={{
            input: {
              color: "white",
              textAlign: "center",
              overflow: "visible",
              width: "100%",
            },
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: "white",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "white",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "white",
            },
          }}
          onChange={(event) => {
            AuthenticationService.updateLanguage(event.target.value);
          }}
        >
          {language_type.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              style={{ textAlign: "center" }}
            >
              <img
                src={option.flag}
                alt={option.label}
                style={{
                  minHeight: "15px",
                  maxHeight: "15px",
                  minWidth: "18px",
                  maxWidth: "18px",
                }}
              />
              {open && <ListItemText>{option.label}</ListItemText>}
            </MenuItem>
          ))}
        </Select>
        <List style={{ position: "absolute", bottom: "0" }}>
          {[
            AuthenticationService.firstName +
              " " +
              AuthenticationService.lastName,
            t("navBar.logout"),
          ].map((text, index) => (
            <ListItem key={text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={() => {
                  if (index === 0) {
                  } else if (index === 1) {
                    AuthenticationService.logout().then((res: any) => {
                      if (!res) navigate(PATHS.Home);
                      else alert("Une erreur s'est produite");
                    });
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    color: "white",
                  }}
                >
                  {index === 0 ? <AccountCircleIcon /> : <ExitToAppIcon />}
                </ListItemIcon>
                {index === 0 ? (
                  <ListItemText
                    primary={text}
                    secondary={AuthenticationService.role}
                    sx={{ opacity: open ? 1 : 0 }}
                    secondaryTypographyProps={{ style: { color: "yellow" } }}
                  />
                ) : (
                  <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
                )}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <AccountManagement
          open={accountManagement}
          closeModal={closeAccountManagement}
          userInformations={userInformations}
        />
        <Settings open={settings} closeModal={closeSettings} />
      </Drawer>
    </>
  );
};

export default NavBar;
